import { REDIRECT_QUERY_NAME } from '~/components/ModalDeliveryAddress/constants';

/** Query param carrying the address type an address modal should show or create. */
export const ADDRESS_USAGE_PARAM = 'address-usage';

/** Query param marking a modal opened to create a new address rather than to change the current one. */
export const ADDRESS_INTENT_PARAM = 'address-intent';

/** Query param naming the open modal. */
export const MODAL_PARAM = 'modal';
export const MODAL_EDIT_ADDRESS_PARAM = 'editAddress';
/** Query param the checkout destination picker reads its initial tab from. */
export const DESTINATION_TAB_PARAM = 'destination';

/** Query params a modal owns; closing it removes every one of them. */
export const MODAL_QUERY_PARAMS = [
  MODAL_PARAM,
  MODAL_EDIT_ADDRESS_PARAM,
  'source',
  'pickup',
  ADDRESS_USAGE_PARAM,
  ADDRESS_INTENT_PARAM,
  DESTINATION_TAB_PARAM,
] as const;

/**
 * The location of the page a modal is open over.
 *
 * A modal is state of the page beneath it, not a page of its own, yet it lives
 * in the query string. Anything that tracks pages has to see through it:
 * otherwise `/cart?modal=…` and `/cart` read as two different pages, and a
 * return to the cart is taken for a fresh visit.
 */
export const locationBeneathModal = (pathname: string, search: string) => {
  const params = new URLSearchParams(search);

  if (!params.has(MODAL_PARAM)) {
    return `${pathname}${search}`;
  }

  for (const param of [...MODAL_QUERY_PARAMS, REDIRECT_QUERY_NAME]) {
    params.delete(param);
  }

  const rest = params.toString();

  return rest ? `${pathname}?${rest}` : pathname;
};
